// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseMethod } from './BaseMethod';
import { BEInterface } from './BEInterface';
import { MethodParameter } from './MethodParameter';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 接口方法 实体类
 * 接口方法
 */
export class InterfaceMethod extends BaseMethod {
  /** 接口 的ID */
  private _interface_ID: string;

  /** 获取：接口 的ID */
  public get interface_ID() {
    return this._interface_ID;
  }

  /** 设置：接口 的ID */
  public set interface_ID(value: string) {
    this._interface_ID = value;
  }

  /** 接口  */
  private _interface: BEInterface;

  /** 获取：接口  */
  public get interface() {
    return this._interface;
  }

  /** 设置：接口  */
  public set interface(value: BEInterface) {
    this._interface = value;
    if (value !== null) {
      this.interface_ID = value.id;
    } else {
      this.interface_ID = '';
    }
  }

  /** 方法参数 */
  private _parameters: Array<MethodParameter>;

  /** 获取：方法参数 */
  public get parameters() {
    return this._parameters;
  }

  /** 设置：方法参数 */
  public set parameters(value: Array<MethodParameter>) {
    this._parameters = value;
  }

  constructor() {
    super();
    this._interface_ID = '';
    this._interface = null;
    this._parameters = new Array<MethodParameter>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: InterfaceMethod, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.interface_ID = element.interface_ID;
      if (hasReference && element.interface !== null) {
        this.interface = element.interface;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.interface_ID = json.Interface_ID;
    // if (json.Interface !== null) {
    //   this.interface = BEInterface.Create(json.Interface);
    // }
    if (json.Parameters && json.Parameters.length > 0) {
      json.Parameters.forEach((element: any) => {
        const methodParameter = MethodParameter.Create(element);
        // methodParameter.interfaceMethod = this;
        this.parameters.push(methodParameter);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Interface_ID = this.interface_ID;
    if (this.parameters && this.parameters.length > 0) {
      json.Parameters = [];
      this.parameters.forEach((element) => {
        json.Parameters.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): InterfaceMethod {
    const interfaceMethod = new InterfaceMethod();
    interfaceMethod.Deserialize(json);
    interfaceMethod.json = json;
    return interfaceMethod;
  }
}
